import React from "react";
import { useNavigate } from "react-router-dom";


function Adminsidebar() {

  const navigate = useNavigate();

  const movetoclassx = (e) => {
       e.preventDefault();
    navigate("/admin-class-x");
  }
   const movetodashboard = (e) => {
    e.preventDefault();
     navigate("/admin-dashboard");
  }
  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        <li className="nav-item nav-b">
          <a className="nav-link back-b" href="" onClick={(e)=>{movetodashboard(e)}}>
            <i className="icon-grid menu-icon"></i>
            <span className="menu-title">Dashboard</span>
          </a>
        </li>
        <li className="nav-item nav-b">
          <a className="nav-link back-b" href="" onClick={(e)=>{movetoclassx(e)}}>
            <i className="icon-grid menu-icon"></i>
            <span className="menu-title">Class X Notice Upload</span>
          </a>
        </li>
        {/* <li className="nav-item nav-b">
          <a className="nav-link back-b" href="" onClick={(e)=>{movetoclassxii(e)}}>
            <i className="icon-grid menu-icon"></i>
            <span className="menu-title">Class XII Notice Upload</span>
          </a>
        </li> */}
      </ul>
    </nav>
  );
}

export default Adminsidebar;
